import React from "react";
import { Content } from "components/Layout";
import Piepagina from "./FooterHomePublica";
import Cabecera from "./CabeceraHomePublica";
const PreguntasFrecuentes = ({ children, carritoVisible }) =>
  <main className="cr-app ">
    <Content fluid>
      <Cabecera carritoVisible={carritoVisible} />
      {children}
      <Piepagina />
    </Content>
  </main>
export default PreguntasFrecuentes;
